module.exports = __webpack_public_path__ + "static/media/newcustomer2.a5ab21fa.svg";